module.exports = __webpack_public_path__ + "img/barraFondo2.cb347598.svg";